module.exports = __webpack_public_path__ + "img/filter.056b87da.svg";